import React from "react";
import { Card, Col, Row } from "antd";
//
//component
import DepositLoading from "component/lottie/deposit_loading";
//redux
//selector
// import { bailiffJobDetailSelector } from "store/bailiff/bailiff/job/bailiff_job.selector";
//actions
//utils
//hook
import { FLOWS, useJobDetailFlow } from "hook/bailiff/job/flow/useJobDetail";

//str
const JobTranscript = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useJobDetailFlow();
  const isFlow = flow === FLOWS.TRANSCRIPT;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderInfo = () => {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
          minHeight: 300,
        }}
      >
        <DepositLoading width={"100%"} height={100} />
        <span
          style={{
            color: "#aeaeae",
            fontSize: 12,
            fontStyle: "italic",
            textAlign: "center",
          }}
        >
          AI đang tiến hành biên dịch dữ liệu. Kết quả sẽ trả về sau khi hoàn
          tất
        </span>
      </div>
    );
  };
  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <Card size="small">
      <Row gutter={[20, 30]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderInfo()}
        </Col>
      </Row>
    </Card>
  );
};
export default JobTranscript;
